/*** @description 全选级联选择器 *@notice v-on="$listeners" 监听父组件的事件，不需要加，加完后全选时候会触发两次change事件 **/
<template>
  <el-cascader
    ref="cascaderRef"
    v-model="selected"
    :props="props"
    :options="options"
    :filter-method="filterMethod"
    @change="selectedChange"
    v-bind="$attrs"
    size="small"
    collapse-tags
    filterable
    clearable
  ></el-cascader>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    props: { type: Object, default: () => ({ value: 'value', label: 'label', children: 'children' }) },
  },
  data() {
    return {};
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    filterMethod(node, keyword) {
      this.filterWord = keyword;
      // 在筛选后的数据中加入全选项
      if (node.value === 'all') {
        return true;
      } else {
        return node.text.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
      }
    },
    selectedChange(val) {
      this.$nextTick(() => {
        const { options, suggestions, filtering } = this.$refs.cascaderRef;
        let t_selected = [];
        if (val.includes('all')) {
          // 点击了全选，选择全部选项
          if (filtering) {
            t_selected = suggestions.map(item => item.value);
            t_selected = [...this.selected, ...t_selected];
            t_selected = [...new Set(t_selected)].filter(item => item !== 'all');
          } else {
            // 点击了全选，选择全部选项
            t_selected = this.getAllValues(options);
          }
          this.selected = t_selected;
          this.$refs.cascaderRef.toggleDropDownVisible(false);
        } else {
          this.selected = [...val];
        }
        this.$nextTick(() => {
          // this.$refs.cascaderRef.focusFirstNode();
          this.$emit('change', this.selected);
        });
      });
    },
    getAllValues(options) {
      const values = [];
      const traverse = items => {
        items.forEach(item => {
          if (item[this.props.children] && item[this.props.children].length > 0) {
            traverse(item[this.props.children]);
            // 如果checkStrictly为true，添加当前节点的值
            this.props.checkStrictly && values.push(item[this.props.value]);
          } else {
            // 如果没有子节点，直接添加当前节点的值
            item[this.props.value] !== 'all' && values.push(item[this.props.value]);
          }
        });
      };
      traverse(options);
      return values;
    },
  },
};
</script>
